import { Behavior } from "./Behavior";
import { DynamicEntity } from "../../core/Entities/DynamicEntity";
import { PathBehavior } from "./PathBehavior";
import { Vec2 } from "@h4x/common";
import { App } from "../../app";
import { DifficultyManager } from "../DifficultyManager";
import { Globals } from "../Constants";
import { SoundManager } from "../../core/SoundManager";

/** Enemy Patroller One (Vertical) Behavior */
export class EnemyPatrollerTwoBehavior extends Behavior<DynamicEntity, number> {
	private pathBehavior: PathBehavior;

	constructor(owner: DynamicEntity) {
		super(owner);

		this.pathBehavior = new PathBehavior(owner);
	}

	public update(dt: number) {
		if (this.active === false) {
			return;
		}

		this.pathBehavior.update(dt);
	}

	public execute(xLocation: number) {
		let path: Vec2[] = [];

		// Horizontal Behavior
		path.push(
			new Vec2(xLocation, 0),
			new Vec2(xLocation, Globals.WORLD_HEIGHT)
		);

		this.owner.setMaxSpeed(DifficultyManager.getPatrollerTwoSpeed());

		this.pathBehavior.setSoundToPlayOnPathChange(SoundManager.PatrollerSpin);
		this.pathBehavior.execute(path);
	}
}
